import React from 'react'
import './CfoSite.css'
import { CfoBrandMark, CfoSiteFooter, navigateTo } from './CfoSiteShared'

type Doc = 'privacy' | 'terms'

const PRIVACY: { heading: string; body: string }[] = [
  { heading: 'What we access', body: 'When you connect a supported accounting platform, CFO Core reads your accounting data (accounts, transactions, and reports) through the provider’s API. We request read-only access and never write to or modify your accounting company.' },
  { heading: 'How we use it', body: 'We use your data solely to build and operate your CFO Core — financial statements, ratios, cash and AR analysis, forecasts, valuation, and presentations — for you and the people you share it with.' },
  { heading: 'Storage & security', body: 'Your data is stored in our secured cloud infrastructure. Provider access and refresh tokens are encrypted at rest. We do not sell your data or share it with advertisers. Xero data is excluded from shared model training and cross-company learning.' },
  { heading: 'Disconnecting', body: 'You can disconnect a provider at any time, which revokes our refresh access. Permanent deletion of imported company data is a separate action available from connection settings.' },
  { heading: 'Contact', body: 'Questions about privacy? Email casey@fusegrid.io.' },
]

const TERMS: { heading: string; body: string }[] = [
  { heading: 'The service', body: 'CFO Core is provided by FuseGrid as a financial analysis product. QuickBooks Online is available and Xero is in private beta; Sage Intacct, Sage Accounting, and NetSuite are planned. Available features depend on provider permissions, reconciled data, and connection status. Xero GL detail and provider-specific AI features remain disabled until their required provider, legal, and security approvals pass.' },
  { heading: 'Your account', body: 'You’re responsible for keeping your login credentials secure and for the accuracy of the information you provide at signup.' },
  { heading: 'Not financial advice', body: 'CFO Core surfaces analysis derived from your books. It is informational and does not constitute accounting, tax, legal, or investment advice. Verify figures before relying on them for decisions.' },
  { heading: 'Availability', body: 'During early access the service is provided “as is,” without warranties, and may experience interruptions.' },
  { heading: 'Contact', body: 'Questions about these terms? Email casey@fusegrid.io.' },
]

export function CfoLegalPage({ doc }: { doc: Doc }) {
  const sections = doc === 'privacy' ? PRIVACY : TERMS
  const title = doc === 'privacy' ? 'Privacy Policy' : 'Terms of Service'
  return (
    <div className="cfo-site">
      <nav className="cfo-site-nav">
        <span style={{ cursor: 'pointer' }} onClick={() => navigateTo('/')}>
          <CfoBrandMark sub="by FuseGrid" />
        </span>
        <div className="cfo-site-nav-links">
          <button className="cfo-btn cfo-btn-primary" onClick={() => navigateTo('/signup')}>Connect your books</button>
        </div>
      </nav>
      <div className="cfo-wrap" style={{ padding: '48px 28px 64px', maxWidth: 760 }}>
        <h1 style={{ fontFamily: 'var(--serif)', fontWeight: 500, fontSize: 34 }}>{title}</h1>
        <div className="cfo-prose">
          {sections.map((s) => (
            <div key={s.heading}>
              <h2>{s.heading}</h2>
              <p>{s.body}</p>
            </div>
          ))}
        </div>
      </div>
      <CfoSiteFooter />
    </div>
  )
}

export default CfoLegalPage
